// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import './channels'

import { fetchAndRender } from './turbo-utils.js'
window.fetchAndRender = fetchAndRender

/** JQUERY **/
// prima di decommentare e utilizzarlo, chiediti:
// 1. non si può fare con alpinejs?
// 2. non si può fare con element.querySelector() oppure element.querySelectorAll()?
// 3. non si può fare con fetch/chiamate http?
// import './jquery-global';

/** ALPINEJS **/
import Alpine from 'alpinejs'
import mask from '@alpinejs/mask'
import morph from '@alpinejs/morph'
import filterChip from './filter-chip'
import prettySelect from './pretty-select'
import prettyMultiSelect from './pretty-multiselect'
import tiptap from './tiptap'
import importUploader from "./import-uploader.js"
import integerStepper from './integer-stepper'
import resizer from "./resizer.js"
window.Alpine = Alpine;
Alpine.plugin(mask);
Alpine.plugin(morph)

// https://alpinejs.dev/globals/alpine-store#registering-a-store
// https://tailwindcss.com/docs/dark-mode#with-system-theme-support
Alpine.store('darkMode', {
  on: false,
  init() {
    this.on = localStorage.theme == 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)
  },
  toggle() {
    this.on = !this.on
    localStorage.theme = this.on ? 'dark' : 'light'
  }
})

Alpine.store('radius', {
  values: [0, 0.25, 0.5, 0.75, 1],
  size: null,
  init(){
    this.size = localStorage.roundness || 0.5
  },
  setAs(radius){
    this.size = radius
    localStorage.roundness = this.size
  }
})

Alpine.store('font', {
  values: ['sans', 'serif', 'mono'],
  current: null,
  init(){
    this.current = localStorage.font || 'sans'
  },
  setAs(font){
    this.current = font
    localStorage.font = this.current
  }
})

Alpine.data('filterChip', filterChip)
Alpine.data('prettySelect', prettySelect)
Alpine.data('prettyMultiSelect', prettyMultiSelect)
Alpine.data('tiptap', tiptap)
Alpine.data('importUploader', importUploader)
Alpine.data('integerStepper', integerStepper)
Alpine.data('resizer', resizer)

// (web)components
import autocomplete from './components/autocomplete/autocomplete.js'
Alpine.data('autocomplete', autocomplete)
import tagcomplete from './components/tagsinput/tagcomplete.js'
Alpine.data('tagcomplete', tagcomplete)
import tagsfilter from './components/tagsfilter/tagsfilter.js'
Alpine.data('tagsfilter', tagsfilter)

// https://alpinejs.dev/plugins/morph#alpine-morph
Alpine.data('tooltip', () => ({
  init(){
    const targetDiv = this.$el.cloneNode(true)
    const message = targetDiv.dataset.tooltip
    const direction = targetDiv.dataset.direction || 'top'
    targetDiv.removeAttribute('x-data') // prevents recursive init

    Alpine.morph(this.$el, `
      <div data-direction="${direction}"
        class="relative [&>.tooltip]:opacity-0 [&>.tooltip>div]:hidden [&>.tooltip]:duration-0 [&:hover>.tooltip]:opacity-100 [&:hover>.tooltip>div]:block [&:hover>.tooltip]:delay-500 [&:hover>.tooltip]:duration-200
        [&[data-direction=bottom]:hover>.tooltip]:top-full
        [&[data-direction=top]:hover>.tooltip]:bottom-full
        [&[data-direction=bottom]:hover>.tooltip]:translate-y-1
        [&[data-direction=top]:hover>.tooltip]:-translate-y-1">
        <div class="tooltip absolute min-w-max left-[50%] -translate-x-[50%] flex justify-center transition ease-in">
          <div class="text-xs rounded-md bg-primary text-primary-foreground px-3 py-1.5">${message}</div>
        </div>
        ${targetDiv.outerHTML}
      </div>
    `)
  }
}))

/* COMPONENTS */
import registerAutocomplete from './components/autocomplete/component.js'
import registerTagsInput from './components/tagsinput/component.js'
import registerTagsFilter from './components/tagsfilter/component.js'
registerAutocomplete()
registerTagsInput()
registerTagsFilter()

/** PLUGINS **/
// http req interface (ajax sub)
// https://axios-http.com/
import axios from "axios"
window.axios = axios

/** CUSTOM **/
import './main';


Alpine.start();

// https://turbo.hotwired.dev/handbook/drive#custom-rendering
document.addEventListener('turbo:before-render', (e) => {
  // override turbo morph with alpine morph
  // permette la copia dello stato dei componenti alpine (di cui turbo se ne frega)
  e.detail.render = (currentEl, newEl) => {
    // https://github.com/livewire/livewire/blob/3.x/js/morph.js#L65
    Alpine.morph(currentEl, newEl, {
      updating: (el, toEl, childrenOnly, skip) => {
        if (typeof el.hasAttribute !== 'function') return

        if(el.hasAttribute('data-turbo-permanent')) return skip()
      }
    })
  }
})

// document.addEventListener("turbo:before-frame-render", (e) => {
//   // override turbo morph with alpine morph
//   // permette la copia dello stato dei componenti alpine (di cui turbo se ne frega)
//   e.detail.render = (currentEl, newEl) => {
//     Alpine.morph(currentEl, newEl)
//   }
// })